module.exports = __webpack_public_path__ + "static/navigator-cdaf1f0565bf72455c1843a8f226de73.png";